(function () {
  'use strict';
  // Anonymous, first-party, tab-only browsing interests. No identifiers or URLs
  // are stored, and no data is transmitted. Do not read/write storage until both
  // preference and analytics processing are permitted by Shopify Customer Privacy.
  var key = 'zc_cart_product_interest_v1';
  var current = window.zcCartProductHandle || null;
  var allowed = false;
  var known = new Set([
    'zalto-universal-glass','zalto-burgundy-glass','zalto-bordeaux-glass',
    'zalto-white-wine-glass','zalto-champagne-glass','zalto-balance-glass',
    'zalto-gravitas-omega','zalto-mystique','zalto-coupe-crystal-clear',
    'zalto-carafe-67','zalto-carafe-no-25','zalto-carafe-no-75',
    'zalto-carafe-no-150','zalto-axium-decanter'
  ]);
  function privacyAllowed() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.preferencesProcessingAllowed !== 'function' ||
        typeof api.analyticsProcessingAllowed !== 'function') return false;
    try {
      return api.preferencesProcessingAllowed() === true &&
        api.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }
  function clear() {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }
  function read() {
    if (!privacyAllowed()) return [];
    try {
      var value = JSON.parse(sessionStorage.getItem(key) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter(function(h) {
        return typeof h === 'string' && known.has(h);
      }).slice(0, 12);
    } catch (e) { return []; }
  }
  function announce() {
    document.dispatchEvent(new CustomEvent('zaltify:product-interest-updated'));
  }
  function record(handle) {
    if (!privacyAllowed() || !known.has(handle)) return;
    var history = read().filter(function(h) { return h !== handle; });
    history.unshift(handle);
    history = history.slice(0, 12);
    try { sessionStorage.setItem(key, JSON.stringify(history)); } catch (e) {}
    announce();
  }
  function reconcile() {
    var next = privacyAllowed();
    if (!next) {
      allowed = false;
      clear();
      announce();
      return;
    }
    allowed = true;
    if (current && known.has(current)) record(current);
  }
  window.zcCartInterest = {
    recent: function () { return read(); },
    enabled: function () { return privacyAllowed(); }
  };
  document.addEventListener('visitorConsentCollected', reconcile);
  var shop = window.Shopify || {};
  if (typeof shop.loadFeatures === 'function') {
    shop.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){
      if (!err) reconcile();
    });
  } else if (shop.customerPrivacy) {
    reconcile();
  }
})();